import Splide from '@splidejs/splide';

new Splide('.splide',
    {
        direction: 'ttb',
        height: '400px',
        perPage: 3,
        perMove: 1,
        gap: '15px',
        rewind: true,
        type: 'slide',
    }).mount();
const images = document.querySelectorAll('.splide-image');
const mainImage = document.querySelector('#family-main-image');
if (mainImage) {
    mainImage.style.backgroundRepeat = "no-repeat";
    mainImage.style.backgroundSize = "contain";
}
if (images) {
    images.forEach(function (image, index) {
        image.addEventListener('click',
            function (event) {
                const imageEl = document.querySelector(".splide-image.is-clicked");
                if (imageEl) {
                    imageEl.classList.remove("is-clicked");
                }
                const imgEl = image.querySelector('.splide__item-image');
                if (imgEl && mainImage) {
                    mainImage.style.backgroundImage = "url(" + imgEl.dataset.imageUrl + ")";
                    mainImage.style.backgroundSize = "contain";
                    mainImage.style.backgroundRepeat = "no-repeat";
                    mainImage.style.backgroundPosition = "center center";
                    image.classList.add("is-clicked");
                }
            });
    });
}